var _rect, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMessageIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    rx: 25,
    fill: "#4AD2A9"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3550_200)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.75 16.5625C13.75 15.0112 15.0112 13.75 16.5625 13.75H33.4375C34.9888 13.75 36.25 15.0112 36.25 16.5625V29.2188C36.25 30.77 34.9888 32.0312 33.4375 32.0312H27.3423L21.9063 36.1094C21.6953 36.2676 21.4097 36.2939 21.168 36.1753C20.9263 36.0566 20.7812 35.8149 20.7812 35.5469V32.0312H16.5625C15.0112 32.0312 13.75 30.77 13.75 29.2188V16.5625ZM20.4297 20.0781C19.8452 20.0781 19.375 20.5483 19.375 21.1328C19.375 21.7173 19.8452 22.1875 20.4297 22.1875H29.5703C30.1548 22.1875 30.625 21.7173 30.625 21.1328C30.625 20.5483 30.1548 20.0781 29.5703 20.0781H20.4297ZM20.4297 24.2969C19.8452 24.2969 19.375 24.7671 19.375 25.3516C19.375 25.936 19.8452 26.4062 20.4297 26.4062H25.3516C25.936 26.4062 26.4062 25.936 26.4062 25.3516C26.4062 24.7671 25.936 24.2969 25.3516 24.2969H20.4297Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3550_200"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22.5,
    height: 22.5,
    fill: "white",
    transform: "translate(13.75 13.75)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessageIcon);
export default __webpack_public_path__ + "static/media/messageIcon.6d527a3a969253fcf30a56ab527994e5.svg";
export { ForwardRef as ReactComponent };